import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from './index.css';
import fonts from '../../../../iconfonts.css';
import {score} from '../../../stores/index'
import {finance as resultsObject} from '../../../stores/index';
import {cropPlan} from "../../../stores";

@observer
export default class FinanceData extends Component {
    getElementsData(id){
        switch(id) {
            case 'input':
                return {title: "Приймання", icon: fonts.iconInput};
            case 'drying':
                return {title: "Сушка", icon: fonts.iconDrying};
            case 'cleaning':
                return {title: "Очищення", icon: fonts.iconCleaning};
            case 'storage':
                return {title: "Зберігання", icon: fonts.iconStoring};
            case 'output':
                return {title: "Вигрузка", icon: fonts.iconOutput};
            case 'transhipment':
                return {title: "Перевалка", icon: fonts.iconTranshipment};
            default:
                break;
        }
    }


  getElements(){
      let data, result = [];
    for(let key in resultsObject){
        if(key === 'docsFee') continue;
        data = this.getElementsData(key);
      result.push(
          <div className={styles.tabs + ((this.state.stage === key) ? " " + styles.active : '')} onClick={() => {
              this.setState({stage: key})}} key={key}>
            <div className={styles.definition}>
              <h4>{data.title}</h4>
              <div className={styles.icon}><i className={data.icon} /></div>
            </div>
            <DefinitionRow />
            <div>
              <FinResRow {...resultsObject[key].wheat} total={resultsObject[key].total["wheat"]} />
              <FinResRow {...resultsObject[key].rape} total={resultsObject[key].total["rape"]} />
              <FinResRow {...resultsObject[key].soy}  total={resultsObject[key].total["soy"]} />
              <FinResRow {...resultsObject[key].sunflower} total={resultsObject[key].total["sunflower"]} />
              <FinResRow {...resultsObject[key].corn} total={resultsObject[key].total["corn"]}/>
              <FinResTotalRow data={resultsObject[key]}
              total={resultsObject[key].total["wheat"]+resultsObject[key].total["rape"]+resultsObject[key].total["soy"]+
              resultsObject[key].total["sunflower"]+resultsObject[key].total["corn"]
              }
              />
            </div>
          </div>
      )
    }
    return result;
  }

  state = {stage:'input'};
  render() {
    return (
      <div className={styles.financeTab}>
        <div className={styles.mainField}>
          <div className={styles.tabCulture}>
            <div className={styles.definition} />
            <div className={styles.definitionDetailed}>Культура</div>
            <div className={styles.row}><div className={styles.cultureCircle + ' ' + styles.wheat}><i className={fonts.wheat}/></div></div>
            <div className={styles.row}><div className={styles.cultureCircle + ' ' + styles.rape}><i className={fonts.rape}/></div></div>
            <div className={styles.row}><div className={styles.cultureCircle + ' ' + styles.soy}><i className={fonts.soy}/></div></div>
            <div className={styles.row}><div className={styles.cultureCircle + ' ' + styles.sunflower}><i className={fonts.sunflower}/></div></div>
            <div className={styles.row}><div className={styles.cultureCircle + ' ' + styles.corn}><i className={fonts.corn}/></div></div>
            <div className={styles.row}>Всього</div>
          </div>
            {this.getElements()}
          <div className={styles.rowcTab + ((this.state.stage === "total") ? " " + styles.active : '')} onClick={()=>this.setState({stage: "total"})}>
            <div className={styles.definition}>
              <h4>Повернення капіталу</h4>
              <div className={styles.icon}><i className={fonts.iconRoce} /></div>
            </div>
            <DefinitionRow />
            <CultureResultRow data={resultsObject} culture='wheat' />
            <CultureResultRow data={resultsObject} culture='rape' />
            <CultureResultRow data={resultsObject} culture='soy' />
            <CultureResultRow data={resultsObject} culture='sunflower' />
            <CultureResultRow data={resultsObject} culture='corn' />
            <FinResTotalRoceRow data={resultsObject} />
          </div>
        </div>
      </div>
    );
  }
}

const FinResRow = (props) => {
  return(
    <div className={styles.row}>
      <div className={styles.hiddenData}>
        <div className={styles.cashYield}>{props.cashYield.toFixed(0)}</div>
        <div className={styles.directExpends}>{props.directExpends.toFixed(0)}</div>
        <div className={styles.revenue}>
          {(props.cashYield - props.directExpends).toFixed(0)} /&nbsp;
          {props.directExpends ? ((props.cashYield - props.directExpends)/props.directExpends*100).toFixed(0) : 0}%
        </div>
        <div className={styles.indirectExpends}>{props.indirectExpends.toFixed(0)}</div>
        <div className={styles.ebitda}>
            {!props.total ? 0 :
                ((props.cashYield - props.directExpends - props.indirectExpends)/(props.total)).toFixed(2)
            }
            {/*{(props.directExpends + props.indirectExpends) ?*/}
                {/*((props.cashYield - props.directExpends - props.indirectExpends)/(props.directExpends + props.indirectExpends)*100).toFixed(0) : 0}%*/}
        </div>
      </div>
      <div className={styles.roce}>
        {((props.cashYield - props.directExpends - props.indirectExpends)/score.total*100).toFixed(2)}%
      </div>
    </div>
  )
};



const FinResTotalRow = (props) => {
  let data = props.data;
 function sum(element='') {
     return Object.keys(data).reduce((previousValue, currentValue) => {
         if(currentValue === 'elem' || currentValue ==='total') return previousValue;
         return previousValue + data[currentValue][element];
     },0);
 }

    return(
    <div className={styles.row}>
      <div className={styles.hiddenData}>
        <div className={styles.cashYield}>
            {sum('cashYield').toFixed(0)}
        </div>
        <div className={styles.directExpends}>
            {sum('directExpends').toFixed(0)}
          </div>
        <div className={styles.revenue}>
            {(sum('cashYield') - sum('directExpends')).toFixed(0)} /&nbsp;
            {sum('directExpends') ? ((sum('cashYield') - sum('directExpends'))/(sum('directExpends'))*100).toFixed(0) : 0}%
        </div>
          <div className={styles.indirectExpends}>
              {sum('indirectExpends').toFixed(0)}
          </div>
        <div className={styles.ebitda}>
            {!props.total ? 0:
                ((sum('cashYield') - sum('directExpends') - sum('indirectExpends'))/props.total).toFixed(2)
            } &nbsp;
            {/*{sum('directExpends') ? ((sum('cashYield') - sum('directExpends') - sum('indirectExpends'))/( sum('directExpends')+ sum('indirectExpends'))*100).toFixed(0) : 0}%*/}
        </div>
      </div>
      <div className={styles.roce}>
          {((sum('cashYield') - sum('directExpends') - sum('indirectExpends'))/score.total*100).toFixed(2)}%
      </div>
    </div>
  )
};

const FinResTotalRoceRow = (props) => {
  let data = props.data;
    function sum(element='') {
        return Object.keys(data).reduce((previousValue, currentValue) => {
            let newData = data[currentValue];
            return previousValue + Object.keys(data[currentValue]).reduce((previousValue, currentValue) => {
                    if(currentValue !== 'elem' && currentValue !== 'total'){
                        return previousValue + newData[currentValue][element];
                    }
                    return previousValue;
                },0);
        },0);
    }

  return(
      <div className={styles.row}>
          <div className={styles.hiddenData}>
              <div className={styles.cashYield}>
                  {sum('cashYield').toFixed(0)}
              </div>
              <div className={styles.directExpends}>
                  {sum('directExpends').toFixed(0)}
              </div>
              <div className={styles.revenue}>
                  {(sum('cashYield') - sum('directExpends')).toFixed(0)} /&nbsp;
                  {sum('directExpends') ? ((sum('cashYield') - sum('directExpends'))/(sum('directExpends'))*100).toFixed(0) : 0}%
              </div>
              <div className={styles.indirectExpends}>
                  {sum('indirectExpends').toFixed(0)}
              </div>
              <div className={styles.ebitda}>
                  {
                      ((sum('cashYield') - sum('directExpends') - sum('indirectExpends'))/((cropPlan.totalWeight['wheat'] +
                          cropPlan.totalWeight['rape'] +
                          cropPlan.totalWeight['soy'] +
                          cropPlan.totalWeight['sunflower'] +
                          cropPlan.totalWeight['corn']) -
                          (cropPlan.currentWeight['wheat'] +
                              cropPlan.currentWeight['rape'] +
                              cropPlan.currentWeight['soy'] +
                              cropPlan.currentWeight['sunflower'] +
                              cropPlan.currentWeight['corn']))).toFixed(2)
                  } &nbsp;
                  {/*{sum('directExpends') ? ((sum('cashYield') - sum('directExpends') - sum('indirectExpends'))/( sum('directExpends')+ sum('indirectExpends'))*100).toFixed(0) : 0}%*/}
              </div>
          </div>
          <div className={styles.roce}>
              <div className={styles.roce}>{((sum('cashYield') - sum('directExpends')- sum('indirectExpends'))/score.total*100).toFixed(2)}%</div>
          </div>
      </div>

  )
};

const DefinitionRow = () => {
  return(
    <div className={styles.definitionDetailed}>
      <div className={styles.hiddenDefinition}>
        <div className={styles.cashYield}>Виручка ($)</div>
        <div className={styles.directExpends}>Прямі витрати ($)</div>
        <div className={styles.revenue}>Маржинальний дохід ($ / %)</div>
        <div className={styles.indirectExpends}>Непрямі витрати ($)</div>
        <div className={styles.ebitda}>EBITDA ($ / т)</div>
      </div>
      <div className={styles.roce}>ROCE (%)</div>
    </div>
  )
};

const CultureResultRow = (props) => {
  let resultsObject = props.data;
  let cashYield = Object.keys(resultsObject).reduce((previousValue, currentValue) => {
      let newData =  resultsObject[currentValue][props.culture];
      return previousValue + newData.cashYield},0).toFixed(0)
    let directExpends = Object.keys(resultsObject).reduce((previousValue, currentValue) => {
        let newData =  resultsObject[currentValue][props.culture];
        return previousValue + newData.directExpends},0).toFixed(0)
    let indirectExpends = Object.keys(resultsObject).reduce((previousValue, currentValue) => {
        let newData =  resultsObject[currentValue][props.culture];
        return previousValue + newData.indirectExpends},0).toFixed(0)
    let total = Object.keys(resultsObject).reduce((previousValue, currentValue) => {
        return previousValue + resultsObject[currentValue].total[props.culture]},0)
  return(
      <div className={styles.row}>
          <div className={styles.hiddenData}>
              <div className={styles.cashYield}>{cashYield}</div>
              <div className={styles.directExpends}>{directExpends}</div>
              <div className={styles.revenue}>
                  {(cashYield - directExpends).toFixed(0)} /&nbsp;
                  {+directExpends ? ((cashYield - directExpends)/directExpends*100).toFixed(0) : 0}%
              </div>
              <div className={styles.indirectExpends}>{indirectExpends}</div>
              <div className={styles.ebitda}>
                  {!(+total) ? 0 :
                      ((cashYield - directExpends - indirectExpends)/(
                          cropPlan.totalWeight[props.culture] - cropPlan.currentWeight[props.culture]
                      )).toFixed(2)
                  }
              </div>
          </div>
          <div className={styles.roce}>
              {Object.keys(resultsObject).reduce((previousValue, currentValue) => {
                  let newData =  resultsObject[currentValue][props.culture];
                  return previousValue + (newData.cashYield - newData.directExpends - newData.indirectExpends)/score.total*100 },0).toFixed(2)}%
          </div>
      </div>

  )
};





// WEBPACK FOOTER //
// ./src/shared/components/Game/FinanceData/index.js